import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';

import ItemNum from './ItemNum';

const scrollToItem = (num) => {
  const item = document.querySelector(`#list-item-${num}`);
  item.scrollIntoView({
    behavior: 'smooth',
  });
};

const renderNums = (n, activeNum, color, observer) => {
  const nums = [];
  for (let i = 0; i < n; i += 1) {
    const num = i + 1;

    const itemEl = document.querySelector(`#list-item-${num}`);

    if (itemEl && observer) observer.observe(itemEl);

    nums.push(
      <ItemNum
        active={activeNum === num}
        color={color}
        handleClick={() => scrollToItem(num)}
        num={num}
      />,
    );
  }
  return nums;
};

const buildThreshold = () => {
  const thresholds = [];
  const numSteps = 100;

  // eslint-disable-next-line no-plusplus
  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
};

const ArticleListNav = ({ color, intro, numOfItems }) => {
  const [activeNum, setActiveNum] = useState(1);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  let scrollDirection = 'down';
  let prevYPosition = 0;

  const setScrollDirection = () => {
    if (document.documentElement.scrollTop >= prevYPosition) {
      scrollDirection = 'down';
    } else {
      scrollDirection = 'up';
    }

    prevYPosition = document.documentElement.scrollTop;
  };

  const observer = new window.IntersectionObserver(
    ([entry]) => {
      const {
        intersectionRatio,
        intersectionRect,
        isIntersecting,
        rootBounds,
      } = entry;
      const listItemValue = entry.target.attributes['data-list-item'].value;
      const currentValue = parseInt(listItemValue, 10);

      setScrollDirection();

      if (isIntersecting) {
        const pctFilled = intersectionRect.height / rootBounds.height;
        if (pctFilled > 0.5 || intersectionRatio === 1) {
          if (
            (scrollDirection === 'down' && currentValue > activeNum) ||
            (scrollDirection === 'up' && currentValue < activeNum)
          ) {
            setActiveNum(currentValue);
            observer.unobserve(entry.target);
          }
        }
      }
    },
    {
      rootMargin: '-73px 0px 0px 0px',
      threshold: buildThreshold(),
    },
  );

  return (
    <div
      className="article__list-nav--wrapper"
      style={{ gridRowEnd: intro ? 2 + numOfItems : 1 + numOfItems }}
    >
      <div
        className={`article__list-nav num-${activeNum} ${
          activeNum > 5 ? 'scroll' : 'sticky'
        }`}
      >
        {renderNums(numOfItems, activeNum, color, observer)}
      </div>
    </div>
  );
};

ArticleListNav.propTypes = {
  color: PropTypes.string,
  intro: PropTypes.string,
  numOfItems: PropTypes.number,
};

export default ArticleListNav;
